import React from 'react';
import DetailCard from './DetailCard';
import styles from './DetailCard.css';

function DetailTermLoan() {
  return (
    <div className={styles['detail-term-loan']}>
      <DetailCard title="Apa itu Moka Capital Term Loan?" border="yellow">
        <p className={styles['text-default']}>
          <b>Moka Capital</b> bekerja sama dengan berbagai partner peminjaman
          dana yang terpercaya dan dilindungi <b>OJK</b> untuk membantu merchant
          Moka dalam mengembangkan bisnis.
        </p>
      </DetailCard>
    </div>
  );
}

export default DetailTermLoan;
